// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Jg8W","modalForm":"UpgradeEpcsModal_modalForm__3mpSa","modalFooter":"UpgradeEpcsModal_modalFooter__khYpV"};